// @flow
import React, { useRef } from 'react';
import { Field } from 'formik';
import {
  FormGroup,
  Label,
  Input,
  Popover,
  PopoverBody,
  InputGroup,
  Button,
} from 'reactstrap';

import { useToggle, useOutsideClick } from '../../../../../hooks';

const PopoverStyles = { minWidth: '276px' };

function showMessageWithValues(numAdult, numChild) {
  const adultMessage = '(12+ years)';
  const childMessage = '(0-12 years)';

  const numAdultMessage = `${numAdult > 1 ? 'adults' : 'adult'} ${adultMessage}`;
  const numChildMessage = `${numChild > 1 ? 'children' : 'child'} ${childMessage}`;

  return `${numAdult} ${numAdultMessage}, ${numChild} ${numChildMessage}`;
}

export default function PassengerInput() {
  const { on, toggle, close } = useToggle();
  const ref = useRef(null);

  useOutsideClick(ref, close, on);

  return (
    <Field>
      {({
        form: {
          values: { numAdults, numChildren },
          setFieldValue,
        },
      }) => (
        <FormGroup>
          <Label className="title">Passenger</Label>
          <InputGroup>
            <Input
              value={showMessageWithValues(numAdults, numChildren)}
              onClick={() => toggle(true)}
              id="Popover1"
              readOnly={true}
            />
          </InputGroup>
          <Popover
            placement="bottom"
            isOpen={on}
            target="Popover1"
            toggle={toggle}
            style={PopoverStyles}
          >
            <PopoverBody>
              <div className="clearfix"/>
              <div ref={ref}>
                <Counter
                  name="numAdults"
                  value={numAdults}
                  title="Adults"
                  onChange={setFieldValue}
                  />
                <Counter
                  name="numChildren"
                  value={numChildren}
                  title="Children (Under 12)"
                  onChange={setFieldValue}
                  minValue={0}
                  />
              </div>
            </PopoverBody>
          </Popover>
        </FormGroup>
      )}
    </Field>
  );
}

type CounterProps = {
  name: string,
  title: string,
  value: string,
  minValue: number,
  onChange: (name: string, value: number) => void,
};

const Counter = ({ name, title, value, onChange, minValue = 1 }: CounterProps) => (
  <div className="passenger-list">
    <p>
      <Label className="title">{title}</Label>
    </p>
    <ul>
      <li>
        <Button
          onClick={() =>
            Number(value) > minValue ? onChange(name, Number(value) - 1) : null
          }
        >
          -
        </Button>
      </li>
      <li>{value}</li>
      <li>
        <Button onClick={() => onChange(name, Number(value) + 1)}>+</Button>
      </li>
    </ul>
  </div>
);



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/SearchForm/FormElements/Pax.js